import DataApi from './DataApi';

class ObjectHealthApi extends DataApi {
  constructor() {
    super('object-health');
  }

  fetchAll(activeOnly = false) {
    return this.get(`/all?activeOnly=${activeOnly ? 'true' : 'false'}`);
  }

  fetchByObject(objectName) {
    return this.get(`/object/${encodeURIComponent(objectName)}`);
  }

  fetchById(id) {
    return this.get(`/${id}`);
  }

  save(payload) {
    if (payload?.id) {
      return this.put(`/${payload.id}`, payload);
    }
    return this.post('', payload);
  }

  toggleActive(id, isActive) {
    return this.put(`/${id}/toggle`, { is_active: isActive });
  }

  deleteConfig(id) {
    return this.delete(id);
  }

  validateConfig(config) {
    return this.post('/validate', { config });
  }
}

export default ObjectHealthApi;
